module.exports = "<div #mainWrapper class=\"main-wrp\">\r\n    <div class=\"list-wrp\">\r\n        <ul class=\"cnt-wrp list-unstyled mb-0\">\r\n            <li *ngFor=\"let item of menus\" class=\"cnt-item\" [class.disabled]=\"item.disabled\" (click)=\"emitResult(item.disabled, item.id)\">\r\n                <span>{{item.nameKey | translate}}</span>\r\n            </li>\r\n        </ul>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/simple-menu.component/simple-menu.component.html
// module id = ./src/app/shared/components/simple-menu.component/simple-menu.component.html
// module chunks = main